// /**
//  * Center - edit
//  */

// React
import React, {useEffect, useState} from 'react';

// react hook form
import {useForm} from 'react-hook-form';

// Client SDK
import Client from 'client-sdk/src/client';
import {GetAllUsersRequestBuilder} from 'client-sdk/src/users/users';

// UI
import {
  TextField,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccount,
  mdiCellphone,
  mdiHomeCityOutline,
  mdiMapMarkerOutline,
  mdiPhone,
  mdiPostOutline,
  mdiStore,
  mdiStore24Hour,
} from '@mdi/js';

// Component
import MapPosition from './mapPosition';

// Type
import {Supervisor} from '../interfaces';
import {User} from '../../users/interfaces';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';

type Props = {
  data: any;
  update: (body: any, callback: () => void) => void;
  close: () => void;
  partnerId: number;
  supervisorsList: Supervisor[];
};

type Inputs = {
  name: string;
  code: string;
  admin: object;
  phoneNumber: number;
  province: string;
  city: string;
  zipCode: string;
  address: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      color: '#8a8a8a',
      marginRight: theme.spacing(1),
    },
    text: {
      width: '100%',
    },
    errorText: {
      color: '#F30000',
      fontSize: '11px',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8a8a8a',
      marginRight: '12px',
      marginTop: '21px',
    },
  })
);

// const
const user = {
  id: 0,
  name: '',
  phoneNumber: '',
  emailAddress: '',
  role: 'NONE',
  status: 'REGISTERED',
} as User;

export default function Edit(props: Props) {
  const {register, handleSubmit, errors, setValue, getValues} = useForm<Inputs>(
    {
      mode: 'onChange',
    }
  );
  const [open, setOpen] = useState(false as boolean);
  const [latLng, setLatLng] = useState({
    lat: props.data.lat,
    lng: props.data.lon,
  } as {
    lat: number | null;
    lng: number | null;
  });

  const classes = useStyles();

  const [supervisorId, setSupervisorId] = useState(
    0 as number | undefined | null
  );
  const [
    openAutocompleteSupervisors,
    setOpenAutocompleteSupervisors,
  ] = React.useState(false);
  const [valueSupervisors, setValueSupervisors] = React.useState<any>(user);
  const [adminId, setAdminId] = useState(0 as number | undefined);
  const [openAutocomplete, setOpenAutocomplete] = React.useState(false);
  const [currentUser, setCurrentUser] = React.useState<User>(user);
  const [options, setOptions] = React.useState<User[]>([user]);
  const loading = openAutocomplete && options.length === 0;

  useEffect(() => {
    if (props.data.id) {
      setValue('name', props.data.name);
      setValue('code', props.data.code);
      setValue('zipCode', props.data.zipCode);
      setValue('phoneNumber', props.data.phoneNumber);
      setValue('province', props.data.province);
      setValue('city', props.data.city);
      setValue('address', props.data.address);
      setLatLng({lat: props.data.lat, lng: props.data.lon});
    }
  }, [props.data]);

  React.useEffect(() => {
    if (!openAutocomplete) {
      setOptions([]);
    }
  }, [openAutocomplete]); // eslint-disable-line react-hooks/exhaustive-deps

  const onSubmit = (data: Inputs) => {
    const {name, phoneNumber, zipCode, address, city, province, code} = data;
    const {partnerId} = props;
    const {id, type, status} = props.data;
    const {lat, lng} = latLng;

    props.update(
      {
        name: name.trim(),
        phoneNumber: phoneNumber.length > 0 ? phoneNumber : null,
        address,
        code,
        partnerId,
        id,
        city: city.trim(),
        province: province.trim(),
        zipCode,
        lat,
        lon: lng,
        supervisorId,
        status: 'ACTIVE',
      },
      () => props.close()
    );
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={5} alignItems="flex-start">
        <Grid container item xs={4} spacing={1} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiStore} size={1} />
            </span>
            <span className={classes.text}>
              <TextField
                fullWidth
                id="name"
                name="name"
                label="نام مرکز"
                inputRef={register({
                  required: true,
                  minLength: 5,
                  maxLength: 25,
                })}
                error={errors.name && true}
              />
              {errors.name && errors.name.type === 'required' && (
                <p className={classes.errorText}>{'فیلد نام مرکز الزامیست'}</p>
              )}
              {errors.name && errors.name.type === 'minLength' && (
                <p className={classes.errorText}>
                  {'مقدار نام مرکز نباید کمتر از 5 کاراکتر باشد'}
                </p>
              )}
              {errors.name && errors.name.type === 'maxLength' && (
                <p className={classes.errorText}>
                  {'مقدار نام مرکز نباید بیشتر از 25 کاراکتر باشد'}
                </p>
              )}
            </span>
          </div>
        </Grid>

        <Grid container item xs={4} spacing={1} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiStore24Hour} size={1} />
            </span>
            <span className={classes.text}>
              <TextField
                fullWidth
                id="code"
                name="code"
                label="کد مرکز"
                InputProps={{
                  readOnly: true,
                }}
                inputRef={register({
                  required: true,
                  minLength: 1,
                  maxLength: 50,
                })}
                error={errors.code && true}
              />
              {errors.code && errors.code.type === 'required' && (
                <p className={classes.errorText}>{'فیلد کد مرکز الزامیست'}</p>
              )}
              {errors.code && errors.code.type === 'minLength' && (
                <p className={classes.errorText}>
                  {'مقدار کد مرکز نباید کمتر از 1 کاراکتر باشد'}
                </p>
              )}
              {errors.code && errors.code.type === 'maxLength' && (
                <p className={classes.errorText}>
                  {'مقدار کد مرکز نباید بیشتر از 50 کاراکتر باشد'}
                </p>
              )}
            </span>
          </div>
        </Grid>

        <Grid container item xs={4} spacing={1} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiPhone}
                style={{transform: 'scale(-1, 1)'}}
                size={1}
              />
            </span>
            <span className={classes.text}>
              <TextField
                fullWidth
                id="phoneNumber"
                name="phoneNumber"
                label="شماره تماس"
                inputRef={register({
                  required: true,
                  minLength: 6,
                  maxLength: 15,
                  pattern: /^([+]+98|0)\d{5,10}$/g,
                })}
                error={errors.phoneNumber && true}
              />
              {errors.phoneNumber && errors.phoneNumber.type === 'required' && (
                <p className={classes.errorText}>
                  {'فیلد شماره تماس الزامیست'}
                </p>
              )}
              {errors.phoneNumber && errors.phoneNumber.type === 'pattern' && (
                <p className={classes.errorText}>
                  {'فرمت فیلد شماره تماس صحیح نیست'}
                </p>
              )}
              {errors.phoneNumber &&
                errors.phoneNumber.type === 'minLength' && (
                  <p className={classes.errorText}>
                    {'مقدار شماره تماس نباید کمتر از 11 کاراکتر باشد'}
                  </p>
                )}
              {errors.phoneNumber &&
                errors.phoneNumber.type === 'maxLength' && (
                  <p className={classes.errorText}>
                    {'مقدار شماره تماس نباید بیشتر از 15 کاراکتر باشد'}
                  </p>
                )}
            </span>
          </div>
        </Grid>

        <Grid container item xs={4} spacing={1} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiPostOutline}
                style={{transform: 'scale(-1, 1)'}}
                size={1}
              />
            </span>
            <span className={classes.text}>
              <TextField
                fullWidth
                id="zipCode"
                name="zipCode"
                label="کد پستی"
                inputRef={register({
                  required: true,
                  minLength: 10,
                  maxLength: 10,
                  pattern: /^\d{10}$/g,
                })}
                error={errors.zipCode && true}
              />
              {errors.zipCode && errors.zipCode.type === 'required' && (
                <p className={classes.errorText}>{'فیلد کد پستی الزامیست'}</p>
              )}
              {errors.zipCode && errors.zipCode.type === 'pattern' && (
                <p className={classes.errorText}>
                  {'فرمت فیلد کد پستی صحیح نیست'}
                </p>
              )}
              {errors.zipCode && errors.zipCode.type === 'minLength' && (
                <p className={classes.errorText}>
                  {'مقدار کد پستی نباید کمتر از 10 کاراکتر باشد'}
                </p>
              )}
              {errors.zipCode && errors.zipCode.type === 'maxLength' && (
                <p className={classes.errorText}>
                  {'مقدار کد پستی نباید بیشتر از 10 کاراکتر باشد'}
                </p>
              )}
            </span>
          </div>
        </Grid>

        <Grid container item xs={4} spacing={1} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiHomeCityOutline} size={1} />
            </span>
            <span className={classes.text}>
              <TextField
                fullWidth
                id="province"
                name="province"
                label="استان"
                inputRef={register({
                  required: false,
                  minLength: 2,
                  maxLength: 20,
                })}
                InputProps={{
                  readOnly: true,
                }}
                error={errors.province && true}
              />
              {errors.province && errors.province.type === 'minLength' && (
                <p className={classes.errorText}>
                  {'مقدار استان نباید کمتر از 2 کاراکتر باشد'}
                </p>
              )}
              {errors.province && errors.province.type === 'maxLength' && (
                <p className={classes.errorText}>
                  {'مقدار استان نباید بیشتر از 20 کاراکتر باشد'}
                </p>
              )}
            </span>
          </div>
        </Grid>

        <Grid container item xs={4} spacing={1} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiHomeCityOutline} size={1} />
            </span>
            <span className={classes.text}>
              <TextField
                fullWidth
                id="city"
                name="city"
                label="شهر"
                inputRef={register({
                  required: false,
                  minLength: 2,
                  maxLength: 20,
                })}
                InputProps={{
                  readOnly: true,
                }}
                error={errors.city && true}
              />
              {errors.city && errors.city.type === 'minLength' && (
                <p className={classes.errorText}>
                  {'مقدار شهر نباید کمتر از 2 کاراکتر باشد'}
                </p>
              )}
              {errors.city && errors.city.type === 'maxLength' && (
                <p className={classes.errorText}>
                  {'مقدار شهر نباید بیشتر از 20 کاراکتر باشد'}
                </p>
              )}
            </span>
          </div>
        </Grid>

        <Grid container item xs={12} spacing={1} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiMapMarkerOutline} size={1} />
            </span>
            <span className={classes.text}>
              <TextField
                fullWidth
                id="address"
                name="address"
                label="آدرس"
                inputRef={register({
                  required: true,
                  minLength: 10,
                  maxLength: 200,
                })}
                error={errors.address && true}
              />
              {errors.address && errors.address.type === 'required' && (
                <p className={classes.errorText}>{'فیلد آدرس الزامیست'}</p>
              )}
              {errors.address && errors.address.type === 'minLength' && (
                <p className={classes.errorText}>
                  {'مقدار آدرس نباید کمتر از 10 کاراکتر باشد'}
                </p>
              )}
              {errors.address && errors.address.type === 'maxLength' && (
                <p className={classes.errorText}>
                  {'مقدار آدرس نباید بیشتر از 200 کاراکتر باشد'}
                </p>
              )}
            </span>
          </div>
        </Grid>
      </Grid>
      <Grid xs={12} style={{margin: '30px 0'}}>
        <div>
          <MapPosition
            style={{height: '300px'}}
            zoom={14}
            center={{lat: 35.6892, lng: 51.389}}
            position={latLng}
            setLatlng={(latLng: {lat: number; lng: number}) => {
              setLatLng(latLng);
            }}
          />
        </div>
      </Grid>
      <Grid
        container
        item
        xs={12}
        spacing={3}
        alignItems="center"
        style={{margin: '30px 0'}}
      >
        <Grid item xs={6}>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="secondary"
            size="large"
            data-cy="search"
          >
            {`ویرایش مرکز`}
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            type="button"
            fullWidth
            variant="contained"
            size="large"
            data-cy="search"
            onClick={props.close}
          >
            {`بستن`}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
